import React, { useEffect, useState } from "react";
// import img3 from '../Assets/add/img3.png';
import axios from "axios";
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { useLocation, useNavigate } from "react-router-dom";
// import { Circle } from "lucide-react";
import { Filter } from "lucide-react";
import { CheckCircle, Clock, XCircle, ArrowDownAZ, ArrowDownZA } from "lucide-react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ArrowLeft, CircleDashed, User } from 'lucide-react';
import { Mail, Phone, MapPin } from 'lucide-react';

const AllAddedVehiclesNew = () => {
    const [states, setStates] = useState([]);
    const [filteredStates, setFilteredStates] = useState([]);
    const [selectedState, setSelectedState] = useState(null);
    const [searchTerm, setSearchTerm] = useState("");
    const [isLoadingStates, setIsLoadingStates] = useState(false);
    const [showOptions, setShowOptions] = useState(false);
    const [showOptionsFor, setShowOptionsFor] = useState(null);
    sessionStorage.setItem("hasVisitedModal", true);
    const [showFilter, setShowFilter] = useState(false);
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(true);
    const [data, setData] = useState([]); // Data from the API
    const [error, setError] = useState(null);
    const [currentType, setCurrentType] = useState('')
    console.log('curretntype', currentType)

    const [KYCData, setKYCData] = useState([]); // State for KYC data
    console.log('kyc123', KYCData)
    const [filteredNotAcceptedData, setFilteredNotAcceptedData] = useState([]);
    const [filteredAccepted, setFilteredAccepted] = useState([]); // State for filtered data
    // State for filtered data
    const token = localStorage.getItem("token");
    const userId = localStorage.getItem("userId");
    const location = useLocation();
    const { state } = useLocation()

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axios.get(
                    `${process.env.REACT_APP_BACKEND_URL}/api/getPendingDriverDetails/${userId}`,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                        },
                    }
                );
                const response2 = await axios.get(
                    `${process.env.REACT_APP_BACKEND_URL}/api/getKYCDetails/${userId}`,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                        },
                    }
                );
                console.log('response2', response2.data.data)
                setKYCData(response2.data.data);

                const filteredNotAcceptedData = response.data.data.filter((item) => !item.isActive)
                const filteredAcceptedData = response.data.data.filter((item) => item.isActive)

                console.log('filtedata', filteredNotAcceptedData)
                setData(filteredNotAcceptedData); // Save the fetched data
                setFilteredNotAcceptedData(filteredNotAcceptedData); // Initialize filtered data
                setFilteredAccepted(filteredAcceptedData)
                if (filteredNotAcceptedData.length !== 0) {
                    setCurrentType("pending");
                    setData(filteredNotAcceptedData);
                }
                else if (filteredNotAcceptedData.length == 0) {
                    setCurrentType("accepted");
                    setData(filteredAcceptedData);
                }
                setIsLoading(false); // Set loading to false

                console.log("Fetched data:", response.data.data); // Log the fetched data
            } catch (err) {
                console.error("Error fetching data:", err);
                setError("Failed to fetch data. Please try again later.");
                setIsLoading(false); // Set loading to false even if there's an error
            }
        };

        fetchData();
    }, []);

    const deleteItem = async (vendorDriverCode) => {
        try {
            // Call the backend API to delete the item
            const response = await axios.delete(
                `${process.env.REACT_APP_BACKEND_URL}/api/deletedVendorDriver/${vendorDriverCode}`
            );

            if (response.status === 200) {
                // Update both `data` and `filteredData` to remove the deleted item
                setData((prevData) => prevData.filter((item) => item.vendorDriverCode !== vendorDriverCode));
                setFilteredNotAcceptedData((prevFilteredData) =>
                    prevFilteredData.filter((item) => item.vendorDriverCode !== vendorDriverCode)
                );

                toast.success("Driver deleted successfully!"); // Show success toast
                console.log(`Vendor driver with code ${vendorDriverCode} deleted successfully.`);
            } else {
                console.error(`Failed to delete vendor driver with code ${vendorDriverCode}.`);
                toast.error("Failed to delete the driver.");
            }
        } catch (err) {
            console.error("Error deleting vendor driver:", err);
            toast.error("Failed to delete the vendor driver. Please try again.");
        }
    };

    const handleSearch = (e) => {
        const val = e.target.value.toLowerCase();
        setSearchTerm(val);

        // Filter the data based on the search term
        const filtered = data.filter((item) =>
            item.vehicleNo.toLowerCase().includes(val)
        );

        setFilteredNotAcceptedData(filtered); // Update the filtered data

        // Show a toast if no data is found
        if (filtered.length === 0) {
            toast.error("No data found!");
        }
    };

    const toggleFilter = () => {
        setShowFilter((prev) => !prev);
    };

    const handleSelect = () => {
        if (selectedState) {
            alert(`You selected: ${selectedState.name}`);
        }
    };

    if (isLoading) {
        return (
            <div className="fixed inset-0 z-[9999] bg-gray-100 bg-opacity-80 flex items-center justify-center">
                <div className="loader2 h-[50px] w-[20px]"></div>
            </div>
        );
    }

    if (error) {
        return (
            <div className="min-h-screen flex items-center justify-center">
                <p className="text-red-500">{error}</p>
            </div>
        );
    }

    const view = (id, vehicleNo, detail) => {
        console.log('id123', id,)
        const details = detail === 'reject' ? detail : null
        console.log('details', details)
        if (currentType == "KYC") {
            navigate('/View-KYC-Details', {
                state: {
                    id: id,
                    vehicleNo: vehicleNo,
                    details: details,
                    currentType: currentType
                }
            });
        }
        if (currentType == 'pending') {
            navigate('/view-details', {
                state: {
                    id: id,
                    vehicleNo: vehicleNo,
                    details: details,
                    currentType: currentType

                }
            });
        }
        if (currentType == 'accepted') {
            // navigate('/view-details-here', {
            //     state: {
            //         id: id,
            //         vehicleNo: vehicleNo,
            //         details: details,
            //         currentType: currentType
            //     }
            // });

              navigate('/view-details', {
                state: {
                    id: id,
                    vehicleNo: vehicleNo,
                    details: details,
                    currentType: currentType
                }
            });
        }

    }



    return (
        <div className="min-h-screen h-screen bg-gradient-to-b from-[#2db6ff] to-[#d97aff] flex flex-col font-satoshi">
            <ToastContainer /> {/* Add ToastContainer */}
            {/* Top section */}

            <div className="p-6 text-white text-center">
                <div onClick={() => navigate(-1)} className='fixed z-[999] top-6 left-3'>
                    <ArrowLeft className="text-black" />
                </div>
                <h1 className="font-bold mb-2 text-[18px] md:text-xl">Vehicle Status</h1>
            </div>





            <div className="bg-white rounded-t-3xl  -mt-4 flex-1 flex-col items-center">

                <div className="flex overflow-x-auto whitespace-nowrap ml-4 mr-4 gap-2 px-2 py-2">
                    {/* <button 
                        onClick={() => {
                            setCurrentType("KYC");
                            // setData(KYCData);
                        }}
                        className={`flex items-center gap-2 px-4 py-1 rounded-2xl shadow-md transition
      ${currentType === "KYC" ? "bg-blue-300" : "bg-[#e7e7e7] hover:bg-blue-200"}`}
                    >
                        <Clock size={20} />
                        KYC
                    </button> */}

                    <button
                        onClick={() => {
                            setCurrentType("pending");
                            setData(filteredNotAcceptedData);
                        }}
                        className={`flex items-center gap-2 px-4 py-1 rounded-2xl shadow-md transition
      ${currentType === "pending" ? "bg-yellow-300" : "bg-[#e7e7e7] hover:bg-yellow-200"}`}
                    >
                        <Clock size={20} />
                        Pending
                    </button>

                    <button
                        onClick={() => {
                            setCurrentType("accepted");
                            setData(filteredAccepted);
                        }}
                        className={`flex items-center gap-2 px-4 py-1 rounded-2xl shadow-md transition
      ${currentType === "accepted" ? "bg-emerald-300" : "bg-[#e7e7e7] hover:bg-emerald-200"}`}
                    >
                        <CheckCircle size={20} />
                        Approved
                    </button>
                </div>

                <div>


                    {/* {showFilter && (
                        <div style={{ boxShadow: '2px 2px 2px' }} className="absolute right-4 transform -translate-y-10 bg-white shadow-xl border rounded-xl w-60 z-50">
                            <ul className="p-2 text-sm">
                                <li className="hover:bg-gray-100 px-3 py-2 rounded cursor-pointer flex items-center gap-2">
                                    <CheckCircle className="w-4 h-4 text-green-500" />
                                    Working Vehicles
                                </li>
                                <li className="hover:bg-gray-100 px-3 py-2 rounded cursor-pointer flex items-center gap-2">
                                    <XCircle className="w-4 h-4 text-red-500" />
                                    Non-Working Vehicles
                                </li>
                                <li className="hover:bg-gray-100 px-3 py-2 rounded cursor-pointer flex items-center gap-2">
                                    <ArrowDownAZ className="w-4 h-4 text-gray-600" />
                                    Sort A to Z
                                </li>
                                <li className="hover:bg-gray-100 px-3 py-2 rounded cursor-pointer flex items-center gap-2">
                                    <ArrowDownZA className="w-4 h-4 text-gray-600" />
                                    Sort Z to A
                                </li>
                            </ul>
                        </div>
                    )} */}
                </div>

                {KYCData.length !== 0 && currentType === 'KYC' && (
                    <div className='h-[100vh]'>

                        <div className="flex-1 mt-3 grid grid-cols-1 overflow-y-auto px-4 py-2  md:grid-cols-4 md:gap-4">
                            {KYCData.map((item, index) => (
                                <div
                                    key={index}
                                    // onClick={() => view(item.vendorCode, item.vehicleNo, item.updatedAt != null && item.isActive == false ? 'reject':null)}
                                    className="flex rounded-xl overflow-hidden shadow-lg border-2 font-sans relative mb-4" style={{ borderColor: '#c7c7c7' }}
                                >



                                    {/* Left Section */}
                                    <div className="bg-white text-gray-900 w-2/3 p-[1rem] relative z-10">
                                        <div className="flex gap-2">
                                            <h2 className="text-[18px] font-bold mb-0">{item.vendorName}</h2>


                                        </div>
                                        <div className="space-y-2 text-sm ">
                                            <div className="flex items-center gap-2 mt-3">
                                                <User size={16} className="text-green-900" />
                                                <span className="text-[12px] font-bold">{item.vendorType == 'craneandrecoveryVan' ? "Hydra + Recovery van" : item.vendorType == 'crane' ? 'Hydra' : 'Recovery van'}</span>
                                            </div>

                                            {/* {item.currentStatus == 2 ? (
                                                <div className="flex gap-2">
                                                    <p className="text-xs text-yellow-600 mt-1">Pending for Approval</p>
                                                </div>
                                            ) : item.currentStatus == 1 ? (
                                                <div className="flex gap-2">
                                                    <p className="text-xs text-green-600 mt-1">Approved</p>
                                                </div>
                                            ) : (
                                                <div className="flex gap-2">
                                                    <p className="text-xs text-red-600 mt-1">Rejected</p>
                                                </div>
                                            )} */}


                                        </div>

                                        <button
                                            onClick={() => {
                                                const detail = (item.currentStatus == 0) ? 'reject' : null;
                                                view(item.vendorCode, null, detail);
                                            }}
                                            className="bg-yellow-400 text-black px-4 py-1 rounded-full font-semibold mt-2">
                                            View
                                        </button>
                                    </div>

                                    <div className="absolute top-1/2 left-[50%] -translate-y-1/2 z-30 flex flex-col items-center gap-1">
                                        {item.currentStatus == 2 ? (
                                            <>
                                                <img
                                                    src="https://static.thenounproject.com/png/3044640-200.png"
                                                    className="h-[3rem] w-[3rem]"
                                                    alt="Pending"
                                                />
                                                <p className="text-xs font-bold text-yellow-800 mt-1">Pending</p>
                                            </>
                                        ) : item.currentStatus == 1 ? (
                                            <>

                                                <img
                                                    src="https://static.vecteezy.com/system/resources/previews/024/382/871/non_2x/approved-sign-symbol-icon-label-stamp-green-round-design-transparent-background-free-png.png"
                                                    className="h-[4rem] w-[6rem]"
                                                    alt="Approved"
                                                />
                                                <p className="text-xs font-bold text-green-600">Approved</p>
                                            </>
                                        ) : (
                                            <>
                                                <img
                                                    src="https://static.vecteezy.com/system/resources/previews/006/566/282/non_2x/rejected-stamp-in-rubber-style-red-round-grunge-rejected-sign-rubber-stamp-on-white-illustration-free-vector.jpg"
                                                    className="h-[5rem] w-[6rem]"
                                                    alt="Correction"
                                                />
                                                <p className="text-xs font-bold text-red-600 mt-1">Correction</p>

                                            </>
                                        )}
                                    </div>
                                    {/* Angled red divider */}
                                    <div className="absolute top-0 bottom-0 left-[60%] w-4 bg-gradient-to-b from-green-400 to-transparent skew-x-[-30deg] z-20"></div>


                                    {/* Right Section with image */}


                                    <div className="absolute top-0 right-0 bottom-0 w-[35%] overflow-hidden z-10 skew-x-[-30deg] origin-left">
                                        <div className="w-full h-full skew-x-[30deg] flex flex-col justify-between p-2">
                                            <img
                                                src="https://media.istockphoto.com/id/1153672822/vector/contract-papers-document-folder-with-stamp-and-text-stack-of-agreements-document-with.jpg?s=612x612&w=0&k=20&c=kjNCXISJ69chBylPnz_pY_jDPlyus3qxB38soxW78J8="
                                                alt="Vehicle"
                                                className="object-contain w-full h-full"
                                            />

                                        </div>
                                    </div>

                                </div>

                            ))}
                        </div>
                    </div>
                )}

                {/* List of Vehicles */}
                {data.length === 0 ? (
                    <div className="flex flex-col items-center justify-center h-[70vh] flex-1">
                        <img src='https://img.freepik.com/free-vector/hand-drawn-no-data-concept_52683-127823.jpg?semt=ais_hybrid&w=740' className="h-[50vh]" />
                        <p className="text-gray-500 text-lg">No data found.</p>
                    </div>
                ) : (
                    <div className='h-[100vh]'>

                        {currentType !== "KYC" && (
                            <div className="flex-1 mt-3 grid grid-cols-1 overflow-y-auto px-4 py-2  md:grid-cols-4 md:gap-4">
                                {data.map((item, index) => (
                                    <div
                                        key={index}
                                        // onClick={() => view(item.vendorCode, item.vehicleNo, item.updatedAt != null && item.isActive == false ? 'reject':null)}
                                        className="flex rounded-xl overflow-hidden shadow-lg border-2 font-sans relative mb-4" style={{ borderColor: '#c7c7c7' }}
                                    >



                                        {/* Left Section */}
                                        <div className="bg-white text-gray-900 w-2/3 p-[1rem] relative z-10">
                                            <div className="flex">
                                                <div>
                                                    <div className="flex gap-2">
                                                        <h2 className="text-[18px] font-bold mb-0 mr-3">{item.vehicleNo}</h2>


                                                    </div>
                                                    <div className="space-y-2 text-sm ">
                                                        <div className="flex items-center gap-2 mt-[1rem]">
                                                            <User size={16} className="text-green-900" />
                                                            <span className="text-[12px] font-bold">{item.driverName}</span>
                                                        </div>

                                                    </div>

                                                    {currentType === "accepted" && (
                                                        <button
                                                            onClick={() => {
                                                                const detail = (item.ReasonOfRejection !== null && item.isActive == false && item.isPending == false) ? 'reject' : null;
                                                                view(item.vendorCode, item.vehicleNo, detail);
                                                            }}
                                                            className="bg-yellow-400 text-black px-4 py-1 rounded-full font-semibold mt-2">
                                                            Edit
                                                        </button>
                                                    )}

                                                    {currentType === "pending" && (
                                                        <button
                                                            onClick={() => {
                                                                const detail = (item.ReasonOfRejection !== null && item.isActive == false && item.isPending == false) ? 'reject' : null;
                                                                view(item.vendorCode, item.vehicleNo, detail);
                                                            }}
                                                            className="bg-yellow-400 text-black px-4 py-1 rounded-full font-semibold mt-2">
                                                            View
                                                        </button>
                                                    )}

                                                    <button hidden
                                                        onClick={() => {
                                                            const detail = (item.ReasonOfRejection !== null && item.isActive == false && item.isPending == false) ? 'reject' : null;
                                                            view(item.vendorCode, item.vehicleNo, detail);
                                                        }}
                                                        className="bg-yellow-400 text-black px-4 py-1 rounded-full font-semibold mt-2">
                                                        Select
                                                    </button>

                                                    {item.currentStatus != 1 && item.pending == 1 && (<p className="text-red-400 text-xs mt-4 "> * Vehicle Approved But KYC Pending </p>)}

                                                </div>


                                                {/* Status Badge - Absolute center over divider */}
                                                <div className="absolute top-1/2 left-[65%] -translate-y-1/2 z-30 flex flex-col items-center gap-1">
                                                    {item.isPending == 1 ? (
                                                        <>
                                                            <img
                                                                src="https://static.thenounproject.com/png/3044640-200.png"
                                                                className="h-[3rem] w-[3rem]"
                                                                alt="Pending"
                                                            />
                                                            <p className="text-xs font-bold text-yellow-800 mt-1">Pending</p>
                                                        </>
                                                    ) : item.isActive === 0 && item.isPending == 0 ? (
                                                        <>
                                                            <img
                                                                src="https://static.vecteezy.com/system/resources/previews/006/566/282/non_2x/rejected-stamp-in-rubber-style-red-round-grunge-rejected-sign-rubber-stamp-on-white-illustration-free-vector.jpg"
                                                                className="h-[5rem] w-[6rem]"
                                                                alt="Correction"
                                                            />
                                                            <p className="text-xs font-bold text-red-600 mt-1">Correction</p>

                                                        </>
                                                    ) : (
                                                        <>
                                                            <img
                                                                src="https://static.vecteezy.com/system/resources/previews/024/382/871/non_2x/approved-sign-symbol-icon-label-stamp-green-round-design-transparent-background-free-png.png"
                                                                className="h-[4rem] w-[6rem]"
                                                                alt="Approved"
                                                            />
                                                            <p className="text-xs font-bold text-green-600">Approved</p>
                                                        </>
                                                    )}
                                                </div>

                                            </div>

                                        </div>



                                        {/* Angled red divider */}
                                        <div className="absolute top-0 bottom-0 left-[60%] w-4 bg-gradient-to-b from-yellow-400 to-transparent skew-x-[-30deg] z-20"></div>


                                        {/* Right Section with image */}

                                        <div className="absolute top-0 right-0 bottom-0 w-[35%] overflow-hidden  skew-x-[-30deg] origin-left">
                                            <div className="w-full h-full skew-x-[30deg] flex flex-col justify-between p-2">
                                                <img
                                                    src={item.VendorType == 'crane'
                                                        ? 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTE_Y8jx2ppWZdrSTWW4cJOr7XsocApPN3gVw&s'
                                                        : 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTGTwtzM49v4xlu9BooHQAP_nGhQkI9eBSqAQ&s'}
                                                    alt="Vehicle"
                                                    className="object-contain w-full h-full"
                                                />

                                            </div>
                                        </div>

                                    </div>

                                ))}
                            </div>)}
                    </div>
                )}

                <div>


                    {/* {localStorage.getItem('typeOfAgreement') == 'non-individual' && ( */}
                    <button style={{ zIndex: "9999" }}
                        onClick={() => { navigate('/add-new-vehicle-details', { state: { value: "additional-vehicles" } }); }} className="fixed bottom-3 right-3 px-4 py-3 rounded-xl text-white bg-[#2db6ff]">
                        Add New Vehicle
                    </button>
                    {/* )} */}
                </div>

            </div>
        </div >
    );
};

export default AllAddedVehiclesNew;